// extracted by mini-css-extract-plugin
export default {"label":"A7wnNLa4gRo_xz80kthx"};